import React from "react"
import { useStaticQuery, graphql, Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"

import Seo from "../components/seo"
import GlobalLayout from "../components/GlobalLayout";
import ProjectCards from "../components/ProjectCards";

// gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)

export default function Home(pageContext) {
  const queryProjects = useStaticQuery(graphql`
  query {
    allMdx(filter: {slug: {regex: "/^projects\//"}}) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            summary
            path
            publish
            featuredImage {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: CONSTRAINED
                  aspectRatio: 1.6
                )
              }
            }
            featuredImageAltText
          }
        }
      }
    }
  }`)

  const projects = queryProjects.allMdx.edges
  return (
    <GlobalLayout pageContext={ pageContext }>
      <Seo title="Home" />
      <ProjectCards>
          
        {projects.map(({node: project},key) => {
          
          const title = project.frontmatter.title
          const subtitle = project.frontmatter.subtitle
          const summary = project.frontmatter.summary
          const path = project.frontmatter.path
          const publish = project.frontmatter.publish

          // Skip porjects not cleared for release
          if (! publish) {
            return false
          }

          var imageComponent = null
          if (project.frontmatter.featuredImage !== null) {
            const featuredImage = project.frontmatter.featuredImage.childImageSharp.gatsbyImageData
            const featuredImageAltText = project.frontmatter.featuredImageAltText
            imageComponent = <GatsbyImage image={featuredImage} alt={featuredImageAltText}/>
          }

          return (
            <div className="projectCard" key={key}>
              <Link to={`/projects/${path}`}>
                <div className="projectCard-featuredImage">
                  {imageComponent}
                </div>
                <div className="projectCard-text">
                  <h1>{title}</h1>
                  <h2>{subtitle}</h2>
                  <p>{summary}</p>
                  <p className="articleLink">&rarr; Go To Project</p>
                </div>
              </Link>
            </div>
          )}
        )}
      </ProjectCards>
    </GlobalLayout>
  )
}